"use client";

import { HeaderMenu, NavItem, NavParent } from "@/components/layout/Header/HeaderMenu";
import { ButtonLink } from "@/components/shared/Button/Button";
import { SiteLink } from "@/components/shared/SiteLink/SiteLink";
import IconHamburger from "@/images/icons/hamburger.svg";
import Logo from "@/images/logos/logo.svg";
import clsx from "clsx";
import { useState } from "react";
import { NavigationQueryResult, PagesQueryResult } from "../../../sanity/types";
import styles from "./Header.module.scss";
import { EmergencyNumber } from "@/components/shared/EmergencyNumber/EmergencyNumber";

interface HeaderProps {
	navigation: NavigationQueryResult;
}

export const Header = ({ navigation }: HeaderProps) => {
	const [isMobileExpanded, setIsMobileExpanded] = useState(false);

	return (
		<header className={styles["header"]}>
			{/* TODO: Emergency Banner */}
			<nav className={styles["header__wrapper"]}>
				<div className={styles["header__secondary"]}>
					<EmergencyNumber />
					<ul className={styles["header__secondary-list"]}>
						<li>
							<SiteLink
								className={styles["header__secondary-link"]}
								href={"https://tasgasnetworks.com.au/network-alerts"}
							>
								Gas Network Alerts
							</SiteLink>
						</li>
						<li>
							<SiteLink
								className={styles["header__secondary-link"]}
								href={"/contact-us"}
							>
								Contact us
							</SiteLink>
						</li>
					</ul>
				</div>
				<div className={styles["header__primary"]}>
					<SiteLink
						className={styles["header__logo-link"]}
						href="/"
					>
						<span className="sr-only">Home</span>
						<Logo className={styles["header__logo"]} />
					</SiteLink>
					<HeaderMenu
						className={styles["header__menu"]}
						navItems={
							navigation?.headerNavigation?.map(item =>
								item._type === "navGroup"
									? ({
											id: item._key,
											label: item.title,
											children: item.children?.map(item => ({
												id: item.link,
												label: item.label,
												href: item.link,
											})),
									  } as NavParent)
									: ({
											id: item._key,
											label: item.label,
											href: item.link,
									  } as NavItem),
							) || []
						}
						isMobileExpanded={isMobileExpanded}
						setIsMobileExpanded={setIsMobileExpanded}
					/>
					<div className={styles["header__mobile-actions"]}>
						<button
							className={styles["header__hamburger"]}
							onClick={() => setIsMobileExpanded(!isMobileExpanded)}
							aria-label="Expand Navigation Menu"
							aria-expanded={isMobileExpanded ? "true" : "false"}
						>
							<IconHamburger />
						</button>
					</div>
				</div>
			</nav>
		</header>
	);
};
